import { useState, useEffect } from 'react';
import { combineStyles } from 'helpers/helpers';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  fetchBrandConfigModulesPack,
  updateBrandConfigModulesPack,
  fetchPaymentTypes,
  selectDefaultPaymentType,
  setEnabledPaymentTypes,
} from 'actions/Brands';
import withStyles from '@material-ui/core/styles/withStyles';
import { toast } from 'react-toastify';

import { modulesNames } from '../consts';
import PaymentMethodView from './PaymentMethod.view';

const PaymentMethodContainer = ({
  classes,
  initialPaymentTypes,
  selectedBrand,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchBrandConfigModulesPack,
  // eslint-disable-next-line no-shadow -- FIXME
  updateBrandConfigModulesPack,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchPaymentTypes,
}) => {
  const { t } = useTranslation();

  const [paymentTypes, setPaymentTypes] = useState(initialPaymentTypes);
  const [modules, setModules] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (selectedBrand) {
      fetchPaymentTypes(selectedBrand);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [selectedBrand]);

  useEffect(() => {
    setPaymentTypes(initialPaymentTypes);
  }, [initialPaymentTypes]);

  useEffect(() => {
    (async () => {
      const modulesConfig = await fetchBrandConfigModulesPack(selectedBrand, [
        modulesNames.PayU,
        modulesNames.Stripe,
        modulesNames.BlueMedia,
        modulesNames.PayNow,
        modulesNames.AdditionalPayment,
        modulesNames.ItemPaymentTypes,
        modulesNames.ConfigClientPanel,
        modulesNames.PayPo,
        modulesNames.Montonio,
      ]);

      setModules(modulesConfig.configuration);
      setIsLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleModuleUpdate = data => {
    const type = data['@type'];
    const module = { ...modules[type], ...data };
    setModules({ ...modules, [type]: module });
  };

  const handleSubmit = async () => {
    try {
      await updateBrandConfigModulesPack(selectedBrand, {
        ...modules,
        ItemPaymentTypes: paymentTypes,
      });

      toast.success(t('success.changesSaved'));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    } catch (e) {
      toast.error(t('notify.cannotSave'));
    }
  };

  const defaultPaymentOptions = [
    {
      label: t('module.configClientPanel.oneTimePayment'),
      value: 2,
    },
    {
      label: t('common.subscription'),
      value: 1,
    },
  ];

  return (
    <PaymentMethodView
      classes={classes}
      modules={modules}
      setModules={setModules}
      isLoading={isLoading}
      handleModuleUpdate={handleModuleUpdate}
      handleSubmit={handleSubmit}
      defaultPaymentOptions={defaultPaymentOptions}
      paymentTypes={paymentTypes}
      setPaymentTypes={setPaymentTypes}
    />
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(
  connect(
    ({ Auth: { selectedBrand }, Brands: { paymentTypes } }) => ({
      initialPaymentTypes: paymentTypes,
      selectedBrand,
    }),
    {
      fetchBrandConfigModulesPack,
      updateBrandConfigModulesPack,
      fetchPaymentTypes,
      selectDefaultPaymentType,
      setEnabledPaymentTypes,
    }
  ),
  withStyles(combinedStyles)
);
export default enhance(PaymentMethodContainer);
